import { checkDynamicFormListUpdatedRoutine, updateDynamicFormListRoutine } from '@/store/modules/dynamicFormList/routines'
import { getAllForms } from '@/api/forms/index'
import { notificationRoutine } from '../notification/routines'
import { toastTopCenterOptions } from '@/config/vue-toast'

export default {
  async [updateDynamicFormListRoutine.TRIGGER](context, payload) {
    if (payload) {
      return context.commit(updateDynamicFormListRoutine.SUCCESS, payload)
    }

    const { data } = await getAllForms()
    if (!data) {
      return context.dispatch(updateDynamicFormListRoutine.FAILURE)
    }
    return context.commit(updateDynamicFormListRoutine.SUCCESS, data)
  },

  async [checkDynamicFormListUpdatedRoutine.TRIGGER](context) {
    if (context.state.dynamicFormList.length) return

    const { data } = await getAllForms()
    if (!data) {
      return context.commit(checkDynamicFormListUpdatedRoutine.FAILURE)
    }
    return context.commit(checkDynamicFormListUpdatedRoutine.SUCCESS, data)
  },

  [updateDynamicFormListRoutine.FAILURE]() {
    this.$store.dispatch(notificationRoutine.TRIGGER, {
      title: 'No matching form found',
      options: { ...toastTopCenterOptions, className: 'toasted-error' },
      text: 'Sorry, we could not find any goals forms for you.'
    })
  },

  [checkDynamicFormListUpdatedRoutine.FAILURE]() {
    this.$store.dispatch(notificationRoutine.TRIGGER, {
      title: 'No matching form found',
      options: { ...toastTopCenterOptions, className: 'toasted-error' },
      text: 'Sorry, we could not find any goals forms for you.'
    })
  }
}
